import { Link } from "react-router-dom";

export const PlankSymbol = ({ className = "h-8 w-8", bar = "#C99A3E" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <rect x="20" y="12" width="14" height="76" rx="2.5" fill="currentColor" />
    <rect x="66" y="12" width="14" height="76" rx="2.5" fill="currentColor" />
    <rect x="8" y="42" width="84" height="14" rx="2.5" fill={bar} />
  </svg>
);

export const Lockup = ({ className = "h-9", reverse = false, stacked = false }) => {
  const kind = stacked ? "s" : "h";
  if (reverse) return <img src={`/brand/lockup-${kind}-dark.png`} alt="H&W Furniture" className={`w-auto ${className}`} />;
  return (
    <>
      <img src={`/brand/lockup-${kind}-light.png`} alt="H&W Furniture" className={`w-auto dark:hidden ${className}`} />
      <img src={`/brand/lockup-${kind}-dark.png`} alt="H&W Furniture" className={`hidden w-auto dark:block ${className}`} />
    </>
  );
};

export const Logo = ({ className = "", onClick }) => (
  <Link to="/" onClick={onClick} data-testid="header-logo-link" className={`flex items-center ${className}`} aria-label="H&W Furniture home">
    <Lockup className="h-9 sm:h-10" />
  </Link>
);
